import React from 'react'
import MainLayout from '../../components/mainlayout'
import { Button, Card, Col, Divider, List, Result, Row, Space, Spin, Table } from 'antd'
import { useNavigate } from 'react-router-dom'

import { SyncOutlined, FileAddOutlined, ReloadOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';
import { getQuotasList, getStockReportsList } from '../../db';




const dataHeader = [{
    title: "Quantité fixer par ONIL", index: "qunatity",
    sorter: {
        compare: (a, b) => a.Stock_initial - b.Stock_initial,
        multiple: 3,
    },
},
{ title: "Quantité recevez", index: "submited" },
{ title: "Quantité restant a livrer", index: "rest" }]


export const QuotaReports = ({ codeLaiterie }) => {
    const { Column, ColumnGroup } = Table;

    const [dataSource, setDataSource] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const usertoken = useSelector((state) => state.token);

    const load = async () => {
        setLoading(true);
        try {
            const answer = await getQuotasList(codeLaiterie, usertoken);
            if (answer.message === "success") {
                let newData = [];
                answer.data.forEach((item, index) => {
                    newData.push({
                        key: item._id,
                        date: new Date(item.date).toLocaleDateString(),
                        "qunatity-PDL0": item.quantity?.PDL0,
                        "qunatity-PDL26": item.quantity?.PDL26,
                        "submited-PDL0": item.submited.PDL0,
                        "submited-PDL26": item.submited.PDL26,
                        "rest-PDL0": parseFloat(item.quantity?.PDL0) - parseFloat(item.submited.PDL0),
                        "rest-PDL26": parseFloat(item.quantity?.PDL26) - parseFloat(item.submited.PDL26),
                        fournisseur: item.fournisseur,
                        lot: item.lot.join(","),
                    })
                })

                console.log('====================================');
                console.log(newData)
                console.log('====================================');
                setDataSource(newData);
                setLoading(false);
            } else {
                throw "Faild getting reports list :" + answer.message;
            }
        } catch (err) {
            console.log('====================================');
            console.log(err);
            console.log('====================================');
            setLoading(false);
        }
    }

    React.useEffect(() => { load(); }, []);

    return (

        <Card title={"Stock Actuel"}
            bordered={false}>
            <Spin spinning={loading} >
                {dataSource.length < 1 ?
                    <Result
                        title="Pas de quotas"
                    />
                    :
                    <div>
                        <Table
                            bordered={true}

                            pagination={{
                                pageSize: 50,
                            }}
                            scroll={{
                                y: 500,
                            }}
                            dataSource={dataSource}>
                            <Column title="Date" dataIndex="date" key="date" />
                            {dataHeader.map((coll, index) => {
                                return (
                                    <ColumnGroup title={coll.title} key={index}>
                                        <Column title="0%" dataIndex={coll.index + "-PDL0"} key={index + coll.index + "-PDL0"} />
                                        <Column title="26%" dataIndex={coll.index + "-PDL26"} key={index + coll.index + "-PDL26"} />
                                    </ColumnGroup>);
                            })}
                            <Column title="LOT" dataIndex="lot" key="lot" />
                            <Column title="Fournisseur" dataIndex="fournisseur" key="fournisseur" />
                        </Table>

                    </div>
                }
            </Spin>
        </Card>
    )
}
